import React from "react";
import { convertMinutesintoHours } from "../../../../utils/utils";
import { renderTimeWithErrorIcon } from "../../../utils";
import StyledToolTip from "../../../../../../common/StyledToolTip";

class ElapseTimeRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeDiff: this.props.getValue(),
    };
  }

  refresh = (props) => {
    this.setState({ timeDiff: props.getValue(props) });
    return true;
  };

  shouldComponentUpdate(_nextProps, _nextState) {
    return this.state.timeDiff !== this.props.getValue(this.props);
  }

  render() {
    const timeDiff = this.props.getValue(this.props);
    if (!timeDiff) {
      return null;
    }
    const time = convertMinutesintoHours(timeDiff);
    const elapsedHours = timeDiff > 60 ? Math.floor(timeDiff / 60) : null;
    return (
      <StyledToolTip
        title={
          elapsedHours
            ? `Elapse Time greater than ${elapsedHours} hour(s)`
            : time
        }
      >
        {renderTimeWithErrorIcon(time, elapsedHours)}
      </StyledToolTip>
    );
  }
}

export default ElapseTimeRenderer;
